import { Controller } from "@hotwired/stimulus"

// Shopping cart for booking services from an org profile
export default class extends Controller {
  static targets = ["bar", "barCount", "barTotal", "sheet", "sheetItems", "sheetTotal", "dateField", "notesField"]
  static values = { orgId: Number, coachId: Number }

  connect() {
    this.items = this.loadCart()
    this.updateUI()
    // Restore button states from saved cart
    this.items.forEach(item => {
      const btn = document.querySelector(`[data-pricing-id="${item.id}"]`)
      if (btn) { btn.classList.add('cart-added'); btn.innerHTML = '<i class="fas fa-check"></i>' }
    })
  }

  loadCart() {
    try {
      const key = `mcc_cart_${this.orgIdValue}`
      return JSON.parse(localStorage.getItem(key) || '[]')
    } catch { return [] }
  }

  saveCart() {
    try {
      const key = `mcc_cart_${this.orgIdValue}`
      localStorage.setItem(key, JSON.stringify(this.items))
    } catch {}
  }

  add(event) {
    const btn = event.currentTarget
    const id = parseInt(btn.dataset.pricingId)
    const name = btn.dataset.pricingName
    const price = parseFloat(btn.dataset.pricingPrice)

    // Toggle — if already in cart, remove
    const existing = this.items.findIndex(i => i.id === id)
    if (existing >= 0) {
      this.items.splice(existing, 1)
      btn.classList.remove('cart-added')
      btn.innerHTML = '<i class="fas fa-plus"></i>'
    } else {
      this.items.push({ id, name, price })
      btn.classList.add('cart-added')
      btn.innerHTML = '<i class="fas fa-check"></i>'
    }
    this.saveCart()
    this.updateUI()
  }

  toggleSheet() {
    if (this.hasSheetTarget) {
      this.sheetTarget.classList.toggle('cart-sheet-open')
    }
  }

  removeItem(event) {
    const id = parseInt(event.currentTarget.dataset.itemId)
    this.items = this.items.filter(i => i.id !== id)
    // Reset the add button
    const addBtn = document.querySelector(`[data-pricing-id="${id}"]`)
    if (addBtn) {
      addBtn.classList.remove('cart-added')
      addBtn.innerHTML = '<i class="fas fa-plus"></i>'
    }
    this.saveCart()
    this.updateUI()
  }

  submit() {
    if (this.items.length === 0) return

    // Check if logged in — if not, save cart and redirect to auth
    const isLoggedIn = document.querySelector('meta[name="current-user"]')
    if (!isLoggedIn) {
      // Cart is already in localStorage — just go to auth
      window.location.href = '/auth'
      return
    }

    const date = this.hasDateFieldTarget ? this.dateFieldTarget.value : ''
    const notes = this.hasNotesFieldTarget ? this.notesFieldTarget.value : ''
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content

    // Create the booking
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/organizations/${this.orgIdValue}/book_services`

    const addField = (name, value) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    }

    addField('authenticity_token', csrf)
    addField('scheduled_date', date)
    addField('customer_notes', notes)
    this.items.forEach((item, i) => {
      addField(`service_ids[]`, item.id)
    })

    // Clear cart on submit
    this.items = []
    this.saveCart()

    document.body.appendChild(form)
    form.submit()
  }

  updateUI() {
    const count = this.items.length
    const total = this.items.reduce((sum, i) => sum + i.price, 0)

    // Bar visibility
    if (this.hasBarTarget) {
      this.barTarget.style.display = count > 0 ? 'flex' : 'none'
    }
    if (this.hasBarCountTarget) {
      this.barCountTarget.textContent = count
    }
    if (this.hasBarTotalTarget) {
      this.barTotalTarget.textContent = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    }

    // Sheet items
    if (this.hasSheetItemsTarget) {
      this.sheetItemsTarget.innerHTML = this.items.map(item =>
        `<div style="display:flex;align-items:center;justify-content:space-between;padding:6px 0;border-bottom:1px solid rgba(255,255,255,0.04);">
          <span style="color:rgba(255,255,255,0.7);font-size:13px;flex:1;">${item.name}</span>
          <span style="color:rgba(255,255,255,0.4);font-size:13px;margin:0 8px;">$${item.price}</span>
          <button style="width:20px;height:20px;border-radius:50%;background:rgba(239,68,68,0.1);border:none;color:rgba(239,68,68,0.5);font-size:9px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;" data-action="click->service-cart#removeItem" data-item-id="${item.id}">✕</button>
        </div>`
      ).join('')
    }
    if (this.hasSheetTotalTarget) {
      this.sheetTotalTarget.textContent = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    }
  }
}
